import { SuggestionKind } from 'owa-search-service';
import { isControlFeatureEnabled } from 'owa-controls-feature-flags';
export default function shouldShowCategoryHeader(tableView, categoryHeaderData) {
    /**
     * If this is folder table then try to use the category name on the MailFolderTableQuery
     * If this is a category search then use the category name from the pill suggestions in the SearchTableQuery
     */
    if (tableView.tableQuery.type == 0 /* Folder */) {
        var mailTableQuery = tableView.tableQuery;
        if (mailTableQuery.viewFilter == 'UserCategory') {
            // Show category header if the view filter is user category
            categoryHeaderData.categoryName = mailTableQuery.categoryName;
        }
    }
    else if (isControlFeatureEnabled('tri-categories-advanced') &&
        tableView.tableQuery.type == 1 /* Search */) {
        // Show the category header if it's a category search
        var searchTableQuery = tableView.tableQuery;
        var categorySuggestions = searchTableQuery.pillSuggestions.filter(function (suggestion) {
            return suggestion.kind == SuggestionKind.Category;
        });
        // Render category header only if we have one pill of type category suggestion
        if (searchTableQuery.pillSuggestions.length == 1 && categorySuggestions.length == 1) {
            categoryHeaderData.categoryName = categorySuggestions[0].Name;
        }
    }
    return categoryHeaderData.categoryName != null;
}
//# sourceMappingURL=shouldShowCategoryHeader.js.map